import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../layout";
import { url } from "../../../config";
import axios from "axios";
import queryString from "query-string";
import Loader from "../../../assets/icons/loader/loader";
import { TabelBooleanText } from "../../../components/view-form-components/tabel-cell-view";
import DeleteModal from "../../../components/modal/delete-modal";
import AdminFilterDrawer from "../../../components/filter/admin-filter-drawer";
import Pagination from "../../../components/pagination";

const ListUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    axios
      .post(`${url}/ffadmin/list`, {
        page: page_no,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        if (res.data.data.rows.length === 0 && page_no > 1) {
          navigate(
            `/admin/users/list?page=${page_no - 1}${
              filters ? `&${filters}` : ""
            }`,
            { replace: true }
          );
          return;
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const filters = searchParams.toString() ? `&${searchParams.toString()}` : "";

  const deleteFnc = (id) => {
    axios
      .post(`${url}/ffadmin/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      <section className="h-full">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-xl font-semibold capitalize">Admin Users List</h2>
          <div className="flex gap-2 relative">
            <AdminFilterDrawer
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              queryParamsData={queryParamsData}
            />
            <Link
              className="px-4 py-2 bg-primary text-white rounded"
              to={`/admin/users/create`}
            >
              Create
            </Link>
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="px-4 py-1 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <section className="h-[calc(100%-3.5rem)] flex flex-col justify-between overflow-auto">
          <div className="w-full max-w-[82.2vw]  overflow-auto h-full">
            <div class="relative overflow-x-auto">
              <table class="w-full text-left rtl:text-right border border-gray-200">
                <thead class="text-gray-700 uppercase">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      #
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Enabled
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td rowSpan={1}>
                        <div className="w-full flex justify-center py-5">
                          <div className="h-[100px] w-[100px]">
                            <Loader />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data.rows?.length ? (
                        <>
                          {data.rows.map((row, index) => {
                            return (
                              <tr key={index} className="border-t bg-white">
                                <td className="p-1 px-2">
                                  {(data?.page - 1) * 10 + (index + 1)}
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.email}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.name}
                                  </span>
                                </td>
                                <td className="px-4 py-2">
                                  <TabelBooleanText value={row?.enabled} />
                                </td>

                                <td className="py-2 sticky right-0 z-10">
                                  <div className="flex gap-3 bg-white px-4">
                                    <Link
                                      to={`/admin/users/view/${row["id"]}`}
                                      className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                    >
                                      View
                                    </Link>
                                    <Link
                                      to={`/admin/users/edit/${row["id"]}`}
                                      className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                    >
                                      Edit
                                    </Link>
                                    <button
                                      onClick={() => {
                                        setdeleteModalShow(true);
                                        setSelectDelete(row["id"]);
                                      }}
                                      className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td>
                            <p className="text-center my-5">No data found</p>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <footer className="flex justify-end items-center w-full">
            <Pagination
              totalPages={parseInt(data?.count) ?? 0}
              pagination={parseInt(data?.page) ?? 0}
              path={`/admin/users/list`}
              filters={filters}
            />
          </footer>
        </section>
      </section>
    </MainLayout>
  );
};

export default ListUsers;
